import { UploadStatus } from '@aus-platform/design-system';
import { HttpStatusCode } from 'axios';
import { ImageSetUploadStage } from './enums';

// Upload pool.
export const MAX_CONCURRENT_IMAGE_UPLOADS = 6;
export const PRESIGNED_URL_BATCH_SIZE = 6;

// Retries.
export const MAX_IMAGE_UPLOAD_RETRIES = 3;
export const RETRY_BASE_DELAY_MS = 1000;
export const RETRY_BACKOFF_FACTOR = 2;
export const retryableHttpStatusCodes: number[] = [
  HttpStatusCode.RequestTimeout,
  HttpStatusCode.TooManyRequests,
];

// Network detection.
export const INITIAL_CONNECTION_TIMEOUT_MS = 10000;
export const PROGRESS_CONNECTION_TIMEOUT_MS = 5000;
export const NETWORK_PING_INTERVAL_MS = 3000;
export const REQUEST_TIMEOUT_MS = 30000;

// Widget sync and cross-tab queue.
export const PROGRESS_DISPATCH_INTERVAL_MS = 500;
export const UPLOAD_QUEUE_CHECK_INTERVAL_MS = 1000;

// Progress.
export const MILLISECONDS_PER_SECOND = 1000;
export const PERCENTAGE_MULTIPLIER = 100;
export const PROGRESS_DECIMAL_PLACES = 2;

// Image selection.
export const MINIMUM_IMAGES_COUNT = 20;
export const ACCEPTED_IMAGE_FILE_TYPES = '.jpg,.png,.jpeg';

// Widget row title.
export const SINGLE_IMAGE_COUNT = 1;

// Messages.
export const MINIMUM_IMAGES_ERROR_MESSAGE = `Minimum ${MINIMUM_IMAGES_COUNT} images required.`;
export const PREPARE_UPLOAD_FAILED_MESSAGE =
  'Unable to prepare the upload. Try again.';
export const IMAGE_UPLOAD_FAILED_MESSAGE = 'Upload failed';
export const MISSING_PRESIGNED_URLS_MESSAGE =
  'Presigned URLs are missing for some images.';
export const VALIDATION_ERROR_PREFIX = 'Validation Error';
export const UPLOAD_INTERRUPTED_MESSAGE = 'Upload interrupted';

export const activeImageSetUploadStages: ImageSetUploadStage[] = [
  ImageSetUploadStage.Starting,
  ImageSetUploadStage.Uploading,
  ImageSetUploadStage.NetworkError,
];

export const pausableImageSetUploadStages: ImageSetUploadStage[] = [
  ImageSetUploadStage.Uploading,
  ImageSetUploadStage.NetworkError,
];

// Stages that count towards speed, time left and time taken.
export const timedImageSetUploadStages: ImageSetUploadStage[] = [
  ImageSetUploadStage.Uploading,
  ImageSetUploadStage.NetworkError,
];

export const finishedImageSetUploadStages: ImageSetUploadStage[] = [
  ImageSetUploadStage.Uploaded,
  ImageSetUploadStage.Failed,
  ImageSetUploadStage.Cancelled,
];

export const nonCancellableImageSetUploadStages: ImageSetUploadStage[] = [
  ImageSetUploadStage.Completing,
  ...finishedImageSetUploadStages,
];

// Row statuses that mean an upload was running when the row mounted.
export const runningUploadStatuses: UploadStatus[] = [
  UploadStatus.InProgress,
  UploadStatus.Paused,
  UploadStatus.NetworkError,
];
